import React from 'react'
import {
  Button,
  ButtonOutline,
  FormDashboardLabel as Label,
  ImagePickerSidebar,
  RedDot,
  SelectCheckbox,
  TagAdder,
  VisibilitySelector,
} from '../../../components'
import { useHistory, Link } from 'react-router-dom'
import colors from '../../../utils/colors'
import { ProgressBar } from '.'
import { ExportPopup } from './export-popup'

const Sidebar = ({form, updateForm}) => {
  const [poppedUp, setPoppedUp] = React.useState(false)
  const history = useHistory()

  return (
    <div>
      <div className="hidden lg:block p-5 rounded mb-8" style={{background: '#f5f5f5'}}>
        {
          form.registrationType === 'internal' &&
          <div>
            <ProgressBar progress={30} total={100} />
            <p className="text-sm text-gray-444">
              Guest Total: 30/100
            </p>
            <div className="flex items-center mb-4">
              <p className="text-sm text-primary underline mr-1">
                <Link to="/dashboard/events/guest-list">
                  View Guests
                </Link>
              </p>
              <RedDot />
            </div>
          </div>
        }

        <p className={`text-sm text-gray-444 ${form.registrationType === 'internal' ? 'mb-4' : 'mb-2'}`}>
          Status: <strong>Approved</strong>
        </p>

        {
          form.registrationType !== 'internal' &&
          <p className="text-sm text-gray-444 mb-4">
            Event Status: <span style={{color: colors.orange}}>Upcoming</span>
          </p>
        }
        {
          form.registrationType === 'internal' &&
          <p className="text-sm text-gray-444 mb-4">
            Event Status: <span className="font-bold">Completed</span>
          </p>
        }

        {
          form.registrationType === 'internal' &&
          <p className="text-sm text-gray-444 mb-5">
            Registration end date: <br/>Aug/20/2020
          </p>
        }
        <Button className="mb-3" onClick={() => history.push('/dashboard/events')}>Submit</Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent py-4"
          onClick={() => history.push('/dashboard/events')}
        >
          Save to Draft
        </ButtonOutline>

        {
          form.registrationType === 'internal' &&
          <div>
            <hr className="my-5"/>

            <ButtonOutline
              transparent
              outlineColor="primary"
              className="text-primary uppercase font-accent py-4"
            >
              Download Report
            </ButtonOutline>
          </div>
        }
      </div>
      <div className="mb-5 lg:mb-10">
        <ImagePickerSidebar label="Poster Image"/>
      </div>
      <div className="mb-5 lg:mb-10">
        <div className="mb-4 lg:mb-0">
          <Label>Visibility</Label>
        </div>
        <VisibilitySelector form={form} updateForm={updateForm} />
      </div>
      <div className="mb-5 lg:mb-10">
        <Label>Suitable For</Label>
        <SelectCheckbox className="text-sm" placeholder="Choose"/>
      </div>
      <div className="mb-8 lg:mb-10">
        <Label>Tag</Label>
        <TagAdder />
      </div>
      {
        form.registrationType === 'internal' &&
        <div className="hidden lg:block mb-10">
          <ButtonOutline
            outlineColor="primary"
            className="text-primary uppercase font-accent py-4"
            onClick={() => setPoppedUp(true)}
          >
            Export To Program
          </ButtonOutline>
        </div>
      }
      {
        poppedUp &&
        <ExportPopup onClose={() => setPoppedUp(false)}/>
      }
      <div className="lg:hidden mb-8">
        <Button thin className="mb-3" onClick={() => history.push('/dashboard/events')}>Submit</Button>
        <ButtonOutline
          transparent
          outlineColor="primary"
          className="text-primary uppercase font-accent"
          onClick={() => history.push('/dashboard/events')}
        >
          Save to Draft
        </ButtonOutline>
        {
          form.registrationType === 'internal' &&
          <div>
            <hr className="my-5"/>
            <ButtonOutline
              outlineColor="primary"
              className="text-primary uppercase font-accent mb-3"
            >
              Download Report
            </ButtonOutline>
            <ButtonOutline
              outlineColor="primary"
              className="text-primary uppercase font-accent"
              onClick={() => setPoppedUp(true)}
            >
              Export To Program
            </ButtonOutline>
          </div>
        }
      </div>
    </div>
  )
}

export { Sidebar }